// Foundations
import { BreakpointsFoundationsZiniaThemes } from './breakpoints-foundations.zinia.themes';
const pxToRem = (px) => px / 16;
const MOBILE = {
    max: `${BreakpointsFoundationsZiniaThemes.M - pxToRem(1)}rem`,
};
const TABLET = {
    min: `${BreakpointsFoundationsZiniaThemes.M}rem`,
    max: `${BreakpointsFoundationsZiniaThemes.L - pxToRem(1)}rem`,
};
const DESKTOP = {
    min: `${BreakpointsFoundationsZiniaThemes.L}rem`,
};
const MediaQueriesFoundationsZiniaThemes = {
    onlyDesktop: `@media (min-width: ${DESKTOP.min})`,
    tabletAndDesktop: `@media (min-width: ${TABLET.min})`,
    onlyTablet: `@media (max-width: ${TABLET.max}) and (min-width: ${TABLET.min})`,
    mobileAndTablet: `@media (max-width: ${TABLET.max})`,
    onlyMobile: `@media (max-width: ${MOBILE.max})`,
    // values for js mediaqueries
    matchMedia: {
        onlyDesktop: `(min-width: ${DESKTOP.min})`,
        onlyTablet: `(max-width: ${TABLET.max}) and (min-width: ${TABLET.min})`,
        onlyMobile: `(max-width: ${MOBILE.max})`,
    },
};
export { MediaQueriesFoundationsZiniaThemes };
//# sourceMappingURL=media-queries-foundations.zinia.themes.js.map